<template>
  <v-container id="approve-content">
    <!-- HEADER -->
    <v-row justify="center" align="center">
      <v-btn
        id="cancel"
        class="elevation-0 pl-0 pr-3"
        color="black--text grey lighten-2"
        @click="$router.push('/signatureChains/list/ALL')"
      >
        <v-icon class="ma-0 pa-0" color="grey darken-3">
          mdi-chevron-left
        </v-icon>
        {{ $t("main.back") }}
      </v-btn>
      <v-col cols="7">
        <span id="filename-text" class="text-h5">

          {{ document?.fileName }}
        </span>
      </v-col>

      <v-col class="d-flex flex-row justify-end">
        <v-btn

          id="approv-doc-button"
          color="success"
          class="mx-4 px-4"
          :loading="isUploading"

          @click="approveOrDecline(true) "
        >
          <v-icon class="mr-1 ml-0">mdi-check-decagram</v-icon>
          {{ $t('dataTable.content.action.approve') }}
        </v-btn>
        <v-btn
          id="decline_btn"
          color="error"
          outlined
          class="px-2"
          :loading="isUploading"
          @click="approveOrDecline(false)"
        >
          <v-icon
            class="mr-1 ml-0"
          >
            mdi-close-circle-outline
          </v-icon>
          {{ $t('dataTable.content.action.decline') }}
        </v-btn>
      </v-col>
    </v-row>
    <!-- /HEADER -->
    <!-- CONTENT -->

    <v-row>
      <v-col>
        <v-text-field
          id="comment_text_field"
          v-model="comment"
          prepend-icon="mdi-comment modalButtonColor--text large"
          persistent-hint
        >
          <template #label>
            <span class="text--secondary">{{ $t('documentSignatureCustomization.comments.label') }}</span>
          </template>
        </v-text-field>
      </v-col>

      <v-col>
        <div>
          <v-overlay
            :absolute="true"
            :value="isUploading"
          >
            <v-progress-circular
              indeterminate
              size="64"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
          <VisibleSignature
            ref="visiblsignature"
            :doc-data="documentBase64"
            :approv-prof="{}"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <!-- <decline-reason-modal
        :visible="declineReasonVisible"
        :signature-id="+$route.params.signatureId"
        :current-signature-id="$route.params.currentSignatureId"
        @declined="back"
        @closed="declineReasonVisible = false"
      ></decline-reason-modal> -->
    </v-row>
  </v-container>
</template>

<script>
import memberRole from '@/views/signature/chains/memberRole'
import VisibleSignature from '../../components/VisibleSignature'
import { showConfirmationMenu, showRequestLoadingDialog, showToastError, showToastSuccess } from '../../event-bus'
import documents from '../../services/api/documents'
import signatures from '../../services/api/signatures'

export default {
  name: 'ApproveCustomization',
  components: {
    VisibleSignature

  },
  data() {
    return {
      // PDF
      isUploading: true,
      document: null,
      documentBase64: null,
      pdfEncrypted: false,
      // Comment
      comment: ''

    }
  },
  async mounted() {
    try {
      await this.downloadDocument()
    } catch (error) {
      console.error('Error in mounted:', error)
    }
  },
  methods: {
    async downloadDocument() {
      this.isUploading = true
      try {
        const blob = await documents.downloadDocument(this.$route.params.docId)
        const docuDto = await documents.getDocument(this.$route.params.docId)
        this.document = docuDto
        this.pdfEncrypted = (docuDto.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (docuDto.security === 'ENCRYPTED_WITH_USER_PASSWORD')
        const base64 = await this.blobToBase64(blob)
        this.documentBase64 = base64.split(',')[1]
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        this.isUploading = false
      }
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    getErrorMessage(error) {
      if (error instanceof Error) {
        return error.message || 'An unknown error occurred.'
      }
      return 'An unknown error occurred'
    },
    async approveOrDecline(isApproved) {
      const req = {
        currentSignatureId: !this.$route.params.currentSignatureId != null ? this.$route.params.currentSignatureId : null,
        comment: this.comment.length > 0 ? this.comment : null
      }
      const docId = this.$route.docId
      try {
        const resp = isApproved ? await signatures.approve(this.$route.params.signatureId, req) : await signatures.decline(this.$route.params.signatureId, req)
        this.$router.push({ name: 'SignatureChains' })
        showToastSuccess(
          isApproved
            ? this.$t('toastMessage.succesfullyApproved') : this.$t('toastMessage.succesfullyDeclined'))
      } catch (error) {
        console.error(error)
      }
    }

  }
}
</script>

<style scoped>
</style>
